import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from "react-router"
import { useUser } from "../Services"
import { User_Data } from '../Services/Agrisys_GqlDataCaller/UserCalls/GQLCalls/getCalls'
import { useTranslation } from "react-i18next"
import { Button, NewInputList, NewInputListHandles, NewModal } from "../Components"
import { frames, glyphs, css, fonts, colors } from "../Styles"
import { ButtonTypes, ListStyle_Types } from '../Definitions'

interface UserInformations_Props {
  isLoginFlow?: boolean
}

export default function UserInformations() {
  const {t} = useTranslation()
  const navigator = useNavigate()
    const [isModalOpen, setIsModalOpen] = useState<boolean>(true)

  const inputRef=useRef<NewInputListHandles>(null)
  const { userToken, getUserData, userData, updateUserData } = useUser()
  const [userDatas, setUserData] = useState<User_Data | undefined>(undefined);
  const [message, setMessage] = useState<string|null>(null)

  useEffect(() => {
    if (userToken) getUserData(userToken)
  },[])

  useEffect(() => {
    setUserData(userData);
  },[userToken, userData, getUserData])

  useEffect(()=> {
    if (userDatas !== undefined) {
      inputRef.current?.refs.current[0].setValue(userDatas.firstname)
      inputRef.current?.refs.current[1].setValue(userDatas.lastname)
      inputRef.current?.refs.current[2].setValue(userDatas.phone)
      inputRef.current?.refs.current[3].setValue(userDatas.email)
      inputRef.current?.refs.current[4].setValue(userDatas.address)
      inputRef.current?.refs.current[5].setValue(userDatas.country)
    }
  }, [userDatas])

  const UpdateData = () => {
    const firstname = inputRef.current?.refs.current[0].value;
    const lastname = inputRef.current?.refs.current[1].value;
    const phone = inputRef.current?.refs.current[2].value;
    const email = inputRef.current?.refs.current[3].value;
    const address = inputRef.current?.refs.current[4].value;
    const country = inputRef.current?.refs.current[5].value;
  
    if (!firstname) {
      inputRef.current?.refs.current[0].setError();
      setMessage("Saving failed");
    } else if (!lastname) {
      inputRef.current?.refs.current[1].setError();
      setMessage("Saving failed");
    } else if (!phone) {
      inputRef.current?.refs.current[2].setError();
      setMessage("Saving failed");
    } else if (!email) {
      inputRef.current?.refs.current[3].setError();
      setMessage("Saving failed");
    } else {
      var NewData = {
        firstname: inputRef.current?.refs.current[0].value,
        lastname: inputRef.current?.refs.current[1].value,
        phone: inputRef.current?.refs.current[2].value,
        email: inputRef.current?.refs.current[3].value,
        address: inputRef.current?.refs.current[4].value,
        country: inputRef.current?.refs.current[5].value
      } as User_Data;
      updateUserData(NewData.firstname, NewData.lastname, NewData.phone, NewData.email, NewData.address, NewData.country, userToken);
      setMessage("Saved");
    }
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  return (
    <frames.DecorBg>
      <NewModal
        modalState
        predefinedButtons={{
          onGoBack: () => navigator(-1)
        }}
        header={t("user.userInformation", {defaultValue: "user information"})}
        mainContent={
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px"}}>
            <NewInputList 
              ref={inputRef}
              placeholders={[
                t("user.firstName", {defaultValue: "first name"}),
                t("user.lastName", {defaultValue: "last name"}),
                t("user.phone", {defaultValue: "phone"}),
                t("user.email", {defaultValue: "email"}),
                t("user.Address", {defaultValue: "address"}),
                t("user.Country", {defaultValue: "country"})
              ]}
              startEnhancers={[glyphs.User({}), glyphs.User({}), glyphs.Phone({}), glyphs.Mail({}), glyphs.Address({}), glyphs.Country({})]}
              isRequired={[true, true, true, true, false, false]}
              listOverrides={{
                listStyle: ListStyle_Types.vertical,
                listGap: "10px"
              }}
              valueOverrides={{
                valueTypes: ["text", "text", "tel", "email", "text", "text"]
              }}
            />
            <Button content={t("buttons.save", {defaultValue: "save"})} onClick={() => UpdateData()}
              buttonType={ButtonTypes.primaryButton}
              overrides={{
                baseButton: {...css.button_FitContent}
              }}
            />
            {message && <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, position: "absolute", zIndex: "9999", top: "305px"}}>{message}</p>}
          </div>
        }/>
    </frames.DecorBg>
  );
}